import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ./~/rc-steps/es/index.js
// module id = 2601
// module chunks = 0